export const QUERY__COUNTRY_CODES = 'countryCodeWhitelist';
